import { all } from 'redux-saga/effects';
import companySettingsSagas from '@Sagas/companySettings';
import configurationsSagas from '@Sagas/configurations';
import deviceSagas from './device';
import heartBeatDetails from './heartBeatDetails';
import imagePathSaga from './images.saga';
import implementationSaga from './implementation';
import integrationsSagas from '../features/IntegrationsTab/integrations/sagas/integrations.saga';
import mapManagementSagas from './mapManagement';
import productsSagas from './products';
import schedules from './schedules.saga';
import sensorDetails from './sensorDetails';
import sensorGroupSaga from './sensorGroup.saga';
import sensorSagas from '@Sagas/sensors';
import stationsSaga from './stations.saga';
import systemConnectionsSagas from './systemConnections';
import tilingSagas from './tiling';
import upsertLiftStationSaga from './upsertStation.saga';
import usersSagas from './users';
import valueMappingsSaga from './valueMapping';
import continuousSensorPeekSaga from './continuousSensorPeek';
import continuousSystemConnectionTest from './continuousSystemConnectionTest';
import continousTenantStackCheck from './continousTenantStackCheck';
import tenantStack from './tenantStack';

export default function* rootSaga() {
	yield all([
		...productsSagas,
		...usersSagas,
		...systemConnectionsSagas,
		...configurationsSagas,
		...companySettingsSagas,
		...sensorSagas,
		...sensorDetails,
		...deviceSagas,
		...implementationSaga,
		...valueMappingsSaga,
		...sensorGroupSaga,
		...stationsSaga,
		...upsertLiftStationSaga,
		...imagePathSaga,
		...heartBeatDetails,
		...integrationsSagas,
		...schedules,
		...mapManagementSagas,
		...tilingSagas,
		...continuousSensorPeekSaga,
		...continuousSystemConnectionTest,
		...continousTenantStackCheck,
		...tenantStack,
	]);
}
